import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

import type { DiskCollection, DiskNode } from '../Contracts/DiskNode'

/** Стеля `limit` «Спільних зі мною» — `GetDiskSharedWithMeAction::MAX_LIMIT`. */
const SHARED_PAGE_LIMIT = 200

/**
 * «Спільні зі мною»: `GET /services/disk/shared-with-me` — найвищі спільні
 * вузли, нові зверху; у рядку `shared` (хто й коли) і моя роль.
 */
export const LoadDiskSharedWithMeTask = async (): Promise<DiskCollection<DiskNode>> => {
    const response = (await restClient.get(
        '/services/disk/shared-with-me',
        { searchParams: { limit: String(SHARED_PAGE_LIMIT) } },
        { forceRefresh: true }
    )) as unknown

    return toCollection(response, toNode)
}
